import React, { useState, useEffect } from 'react';

//services
import AppChargersService from '../../AppChargersService';

//styles
import {
  ButtonStyles,
  DivStyles,
  InputStyles,
  TextStyles,
} from '../../../../SharedStyles';

const ChargerOCPPMessage = ({
  charger,
}) => {
  const [newMessage, setNewMessage] = useState('');
  const [messageHistory, setMessageHistory] = useState([]);

  const handleChange = (e) => {
    if (e.target.name === 'newMessage') {
      setNewMessage(e.target.value);
    }
  };
  
  const fetchMessages = async () => {
    try {
      const messages = await AppChargersService.getLastDeviceMessageTracesForCharger(charger.iotHubDeviceId);
      setMessageHistory(messages.map((msg, index) => (
        <div key={index}>
          <strong>{msg.direction} {new Date(msg.received).toLocaleString()}:</strong> {msg.payload}
        </div>
      )));
    } catch (error) {
      console.error('Error fetching message history:', error);
    }
  };

  useEffect(() => {
    if (charger) {
      fetchMessages();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [charger]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage || newMessage.trim() === '') {
      return;
    }
    try {
      const msg = {
        iotHubDeviceId: charger.iotHubDeviceId,
        // messageType: 0, //optional
        envelopedMessage: newMessage,
      };
      await AppChargersService.handleCloudToDeviceMsgRequest(msg);
      // Update message history to include the newly sent message
      fetchMessages();
      setNewMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
    }
  }

  return (
    <DivStyles
      justifyContent='space-between'
      alignItems='center'
      padding='0 10px'
      size='14px'
      borderTop='1px solid #f3f3f3'>
      <DivStyles padding='0 0 10px 0' display='flex' alignItems='center'>     
        <ButtonStyles 
        margin='5px 0 0' 
        whiteSpace='nowrap'
        onClick={handleSendMessage}>Send</ButtonStyles> 
        <InputStyles
          width='100%'
          margin='0 0 0 10px'
          type='text'
          name='newMessage'
          placeholder='OCPP message'
          value={newMessage || ''}
          onChange={handleChange}
          required
        />
      </DivStyles>           
      <DivStyles padding='0 0 10px 0' display='flex' alignItems='start'>     
        <ButtonStyles 
        margin='5px 0 0' 
        whiteSpace='nowrap'
        onClick={fetchMessages}>History</ButtonStyles> 
        <TextStyles
          width='100%'
          margin='0 0 0 10px'
        >
          {messageHistory}
        </TextStyles>
      </DivStyles>      
    </DivStyles>
  );
};

export default ChargerOCPPMessage;
